/**
 * The investor's offer form rules, shared by the signed-in submit-offer page
 * and the partner link page so the two cannot drift.
 */

import type { DefaultValues } from 'react-hook-form'
import { z } from 'zod'
import { zodNumber } from '@/core/utils/form'

export const offerFormSchema = z.object({
  offer_price: zodNumber.requiredPositive('Offer price is required'),
  earnest_money_deposit: zodNumber.optionalPositive().refine(
    (val) => val === undefined || val === null || (val >= 0 && val <= 100),
    { message: 'Must be between 0 and 100' }
  ),
  closing_timeline: z.enum(['10_days', '14_days', '30_days', 'flexible']).optional(),
  notes: z.string().max(5000, 'Notes must be 5000 characters or less').optional(),
  private_notes: z.string().max(5000, 'Private notes must be 5000 characters or less').optional(),
})

export type OfferFormData = z.infer<typeof offerFormSchema>

/** Empty form: the masked number inputs start blank rather than at zero. */
export const OFFER_FORM_DEFAULT_VALUES: DefaultValues<OfferFormData> = {
  offer_price: undefined,
  earnest_money_deposit: undefined,
  closing_timeline: undefined,
  notes: '',
  private_notes: '',
}
